import { render, staticRenderFns } from "./LinkBuilding.vue?vue&type=template&id=20073e1e&scoped=true"
import script from "./LinkBuilding.vue?vue&type=script&lang=js"
export * from "./LinkBuilding.vue?vue&type=script&lang=js"
import style0 from "./LinkBuilding.vue?vue&type=style&index=0&id=20073e1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20073e1e",
  null
  
)

export default component.exports